import React, { useState } from "react";
import { Container, Stack, Tab, Tabs } from "react-bootstrap";
import NavCrumbs from "../../../common/NavCrumbs";
import useBreadcrumbs from "../../../hooks/useBreadCrumbs";
import ConfigurationDashboard from "./components/Configuration/ConfigurationDashboard";
import StandardChargesDashboard from "./components/Standard Charges/StandardChargesDashboard";

export const BillingDashboard = () => {
  const breadcrumbs = useBreadcrumbs();
  const [activeTab, setActiveTab] = useState<string>("Configuration");
  const [activeCardFromChild, setActiveCardFromChild] = useState<string>(
    "Master Billing List",
  );
  const handleTabChanges = (key: string | null) => {
    if (key) setActiveTab(key);
  };

  const [triggerAdd, setTriggerAdd] = useState(0);

  const handleAddLocation = () => {
    setTriggerAdd(1);
  };

  return (
    <div>
      <div className="breadcrumbg">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <div className="pt-0 flex-column d-flex align-items-start fade-in-left">
              <h4>
                {triggerAdd == 0 ? "Billing Overview" : "Billing Configuration"}
              </h4>
              <NavCrumbs breadcrumbs={breadcrumbs} />
            </div>
            <div className="p-2 ms-auto">
              {triggerAdd === 0 &&
                activeCardFromChild === "Master Billing List" && (
                  <button
                    onClick={handleAddLocation}
                    className="btn btn-primary d-flex align-items-center fade-in-right"
                  >
                    <span className="material-icons me-2">add</span>
                    {activeTab === "Configuration"
                      ? "Configure"
                      : "Standard Charges"}
                  </button>
                )}
            </div>
          </Stack>
        </Container>
      </div>
      <div className="main_wrapper_section pills_wrapper ">
        <div className="px-5">
          <Tabs
            activeKey={activeTab}
            onSelect={handleTabChanges}
            className={`mt-3 mb-3 fade-in-left ${
              triggerAdd === 1 ? "d-none" : ""
            }`}
          >
            <Tab eventKey="Configuration" title="Configuration">
              <ConfigurationDashboard
                triggerAdd={triggerAdd}
                setTriggerAdd={setTriggerAdd}
                activeTab={activeTab}
                onActiveCardChange={setActiveCardFromChild}
              />
            </Tab>

            <Tab eventKey="Standard Charges" title="Standard Charges">
              <StandardChargesDashboard
                triggerAdd={triggerAdd}
                setTriggerAdd={setTriggerAdd}
                activeTab={activeTab}
              />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};
